import { type ComponentType, useEffect } from 'react';
import { useLazyPhase } from '@atlassian/react-loosely-lazy/phase/context';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LoadingPhaseManager: ComponentType<Record<any, any>> = () => {
	const { startNextPhase } = useLazyPhase();

	useEffect(() => {
		/**
		 * Only start next phase if we are not in the SPA, because there is a second
		 * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
		 * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
		 * bundles too early.
		 */
		if (__SPA__) {
			return;
		}

		/* Outside the SPA, we don't currently have a good proxy for page loads.
		 * So for now we start the "after paint" phase a few seconds after mounting.
		 */
		setTimeout(() => {
			performance.mark('rll-after-paint-phase');
			startNextPhase();
		}, 2000);
	}, [startNextPhase]);

	return null;
};
